import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import React, { useContext, useRef, useState } from 'react';
import * as stylex from '@stylexjs/stylex';
import Icon from "noood/comp/ui/feather-icon/Icon";
import { RandomStringGenerator } from "noood/util/rand/RandomStringGenerator";
import { form_validator } from "noood/comp/form/FormFieldValidator";
import { styling } from "noood/styles/styles.stylex";
import PickDateCalendarBody from "noood/comp/date/picker/PickDateCalendarBody";
import { string_util } from "noood/util/string/StringUtil";
import { FormContext, TableSearchBarContext } from "noood/contexts/contexts";
import { color } from "noood/util/ui/color";
require("date-utils");
export default function PickDate(props) {
  var _props$width, _props$validations, _props$validations$in, _tableSearchBarContex, _props$styling, _props$styling2, _ref, _formCtx$formObj$prop, _formCtx$formObj, _props$styling3, _formCtx$formObj3, _tableSearchBarContex2;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    calendarDeltas = _useState2[0],
    setCalendarDeltas = _useState2[1];
  var _useState3 = useState(new Date()),
    _useState4 = _slicedToArray(_useState3, 2),
    dateObj = _useState4[0],
    setDateObj = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    chosenDate = _useState6[0],
    setChosenDate = _useState6[1];
  var _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    isFocused = _useState8[0],
    setIsFocused = _useState8[1];
  var _useState9 = useState(),
    _useState0 = _slicedToArray(_useState9, 2),
    calendarBody = _useState0[0],
    setCalendarBody = _useState0[1];
  var textfieldRef = useRef();
  var fieldRef = useRef();
  var formCtx = useContext(FormContext);
  var tableSearchBarContext = useContext(TableSearchBarContext);
  var prevMonth = new Date(structuredClone(dateObj).setDate(1)).add({
    'months': -1
  });
  var nextMonth = new Date(structuredClone(dateObj).setDate(1)).add({
    'months': 1
  });
  var thisMonthWith1asDate = new Date(structuredClone(dateObj).setDate(1));
  var thisMonthWithLastDate = new Date(structuredClone(nextMonth).add({
    'days': -1
  }));
  var prevMonthWithLastDay = new Date(structuredClone(thisMonthWith1asDate).add({
    'days': -1
  }));
  var prevMonthLastDayInWeek = prevMonthWithLastDay.getDay();
  var prevMonthNumberOfDays = prevMonthWithLastDay.getDate();
  var daysInThisMonth = thisMonthWithLastDate.getDate();
  var prevMonthLastDaysStart = prevMonthNumberOfDays - prevMonthLastDayInWeek;
  var showPrevMonthLastDays = prevMonthLastDayInWeek !== 6;
  var nextMonthFirstDayInWeek = nextMonth.getDay();
  var todayStr = new Date().toFormat('YYYY-MM-DD');

  // console.log(`daysInThisMonth: `, daysInThisMonth);
  // console.log(`prev month: `, prevMonth);
  // console.log(`next month: `, nextMonth);
  // console.log(`thisMonthWith1asDate: `, thisMonthWith1asDate);
  // console.log(`previousMonthWithLastDay: `, prevMonthWithLastDay);
  // console.log(`prevMonthLastDayInWeek: `, prevMonthLastDayInWeek);
  // console.log(`thisMonthWithLastDate: `, thisMonthWithLastDate);
  // console.log(`previousMonthLastDaysStart: `, prevMonthLastDaysStart);
  // console.log(`nextMonthFirstDayInWeek: `, prevMonthLastDaysStart);
  // console.log(`todayStr: `, todayStr);

  var calDays = [];
  calDays = prevMonthLastDayInWeek === 6 ? calDays : calDays.concat(Array(prevMonthLastDayInWeek + 1).fill(prevMonthLastDaysStart).map(function (v, i) {
    return v + i;
  }));
  calDays = calDays.concat(Array(daysInThisMonth).fill(1).map(function (v, i) {
    return v + i;
  }));
  calDays = nextMonthFirstDayInWeek === 0 ? calDays : calDays.concat(Array(7 - nextMonthFirstDayInWeek).fill(1).map(function (v, i) {
    return v + i;
  }));
  // console.log(`calDays: `, calDays);

  var id = RandomStringGenerator.alphanum(10);
  var cellWidth = ((_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 220) / 7;
  var cellFontSize = cellWidth >= 24 ? 14 : 12;
  var isRequired = ((_props$validations = props.validations) === null || _props$validations === void 0 || (_props$validations$in = _props$validations.indexOf) === null || _props$validations$in === void 0 ? void 0 : _props$validations$in.call(_props$validations, "required")) > -1;
  var valueFromTableSearchBarForm = tableSearchBarContext === null || tableSearchBarContext === void 0 || (_tableSearchBarContex = tableSearchBarContext.form) === null || _tableSearchBarContex === void 0 || (_tableSearchBarContex = _tableSearchBarContex[props.name]) === null || _tableSearchBarContex === void 0 ? void 0 : _tableSearchBarContex.value;
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.label && /*#__PURE__*/React.createElement("span", null, props.label, " ", isRequired && "*"), props.label === void 0 && !props.no_label && props.name && /*#__PURE__*/React.createElement("span", null, string_util.uc_words(props.name, '_'), " ", isRequired && "*"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column"
    }
  }, /*#__PURE__*/React.createElement("div", _extends({}, stylex.props(ui.textfield_container, isFocused && styling.focusRing, isRequired && ui.required), {
    ref: fieldRef,
    style: _objectSpread({}, (_props$styling = props.styling) === null || _props$styling === void 0 ? void 0 : _props$styling.container)
  }), /*#__PURE__*/React.createElement(Icon, {
    icon: "calendar",
    color: (_props$styling2 = props.styling) === null || _props$styling2 === void 0 ? void 0 : _props$styling2.iconColor
  }), /*#__PURE__*/React.createElement("input", _extends({
    ref: textfieldRef
  }, stylex.props(ui.textfield, isRequired && ui.required), {
    value: (_ref = (_formCtx$formObj$prop = formCtx === null || formCtx === void 0 || (_formCtx$formObj = formCtx.formObj) === null || _formCtx$formObj === void 0 ? void 0 : _formCtx$formObj[props.name]) !== null && _formCtx$formObj$prop !== void 0 ? _formCtx$formObj$prop : valueFromTableSearchBarForm) !== null && _ref !== void 0 ? _ref : "",
    placeholder: props.placeholder,
    onFocus: function onFocus(e) {
      setIsFocused(true);
      if (chosenDate) {
        // set the dateObj to this date
        setDateObj(new Date(chosenDate));
      }
    },
    onBlur: function onBlur(e) {
      setIsFocused(false);
    },
    onClick: function onClick(e) {
      var _formCtx$formObj2;
      setCalendarBody(/*#__PURE__*/React.createElement(PickDateCalendarBody, {
        width: 190,
        contextSetter: setCalendarBody,
        sender: fieldRef.current,
        value: formCtx === null || formCtx === void 0 || (_formCtx$formObj2 = formCtx.formObj) === null || _formCtx$formObj2 === void 0 ? void 0 : _formCtx$formObj2[props.name],
        max: props.max,
        min: props.min,
        __choose: function __choose(val) {
          var _formCtx$__collect, _props$_choose;
          formCtx === null || formCtx === void 0 || (_formCtx$__collect = formCtx.__collect) === null || _formCtx$__collect === void 0 || _formCtx$__collect.call(formCtx, props.name, val, form_validator.validate(props.validations, val));
          (_props$_choose = props._choose) === null || _props$_choose === void 0 || _props$_choose.call(props, val);
        }
      }));
    },
    style: (_props$styling3 = props.styling) === null || _props$styling3 === void 0 ? void 0 : _props$styling3.inputField
  })), ((formCtx === null || formCtx === void 0 || (_formCtx$formObj3 = formCtx.formObj) === null || _formCtx$formObj3 === void 0 ? void 0 : _formCtx$formObj3[props.name]) || (tableSearchBarContext === null || tableSearchBarContext === void 0 || (_tableSearchBarContex2 = tableSearchBarContext.form) === null || _tableSearchBarContex2 === void 0 || (_tableSearchBarContex2 = _tableSearchBarContex2[props.name]) === null || _tableSearchBarContex2 === void 0 ? void 0 : _tableSearchBarContex2.value)) && /*#__PURE__*/React.createElement("div", _extends({
    onClick: function onClick(e) {
      var _formCtx$__collect2, _props$_choose2;
      setChosenDate(undefined);
      formCtx === null || formCtx === void 0 || (_formCtx$__collect2 = formCtx.__collect) === null || _formCtx$__collect2 === void 0 || _formCtx$__collect2.call(formCtx, props.name, null, form_validator.validate(props.validations, undefined));
      (_props$_choose2 = props._choose) === null || _props$_choose2 === void 0 || _props$_choose2.call(props, undefined);
    }
  }, stylex.props(ui.clear_button, isRequired && ui.clear_button_on_required)), /*#__PURE__*/React.createElement(Icon, {
    icon: "x",
    size: 13,
    color: isRequired ? "".concat(color.appendAlpha('#333333', 50)) : "var(--shade-40)"
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      height: 0,
      position: "relative"
    }
  }, calendarBody))));
}
PickDate.displayName = '__pick_dt';

// @ts-ignore
_inject(".ev78zum5{display:flex}", 3000);
_inject(".ev1525slw{color:#333}", 3000);
_inject(".ev1l1ennw{justify-content:space-around}", 3000);
_inject(".ev1j6dyjg{font-size:11px}", 3000);
_inject(".evtvhhri{text-transform:uppercase}", 3000);
_inject(".ev1qhh985{border-bottom-width:0}", 4000);
_inject(".ev1q0q8m5{border-bottom-style:solid}", 4000);
_inject(".evnzhmsc{border-bottom-color:#ccc}", 4000);
_inject(".evztvwtv{padding:4px 0}", 1000);
_inject(".ev2b8uid{text-align:center}", 3000);
_inject(".evh8yej3{width:100%}", 4000);
_inject(".evl56j7k{justify-content:center}", 3000);
_inject(".ev1k5a8pd{padding:3px auto}", 1000);
_inject(".evl5kmx0{color:#808080}", 3000);
_inject(".ev6s0dn4{align-items:center}", 3000);
_inject(".ev1fgtraw{height:28px}", 4000);
_inject(".evif65rj{font-size:14px}", 3000);
_inject(".ev1ypdohk{cursor:pointer}", 3000);
_inject(".evxwrc4x{border-radius:var(--roundness)}", 2000);
_inject(".ev17e5z5g{color:var(--text-color)}", 3000);
_inject(".evotx0s4:hover{background-color:var(--shade-light)}", 3130);
_inject(".ev1h2kqdt{transition:background-color .2s}", 2000);
_inject(".evjbqb8w{background-color:transparent}", 3000);
_inject(".ev1dfczft:hover{background-color:var(--shade-05)}", 3130);
_inject(".evfge0gx:active{background-color:var(--shade-10)}", 3170);
_inject(".ev1e41zw8{padding:1px 5px}", 1000);
_inject(".ev1ghz6dp{margin:0}", 1000);
_inject(".evc342km{border-width:0}", 2000);
_inject(".ev12oqio5{border-radius:4px}", 2000);
_inject(".evrvj5dj{display:grid}", 3000);
_inject(".ev1mzazjb{grid-template-columns:repeat(7,1fr)}", 3000);
_inject(".ev1lcnupm{color:var(--shade-10)}", 3000);
_inject(".evgk6v1k{border-with:1px}", 3000);
_inject(".ev1y0btm7{border-style:solid}", 2000);
_inject(".ev119ba7t{border-color:var(--accent)}", 2000);
_inject(".ev18jlpol{background-color:#eee}", 3000);
_inject(".evmfpazt{padding:2px 8px}", 1000);
_inject(".evbjeahn{border-top-right-radius:5px}", 4000);
_inject(".ev1w61mk2{border-bottom-right-radius:5px}", 4000);
_inject(".ev1y7ric0{background-color:var(--shade-05)}", 3000);
_inject(".evmkeg23{border-width:1px}", 2000);
_inject(".evsqfd0d{border-color:var(--shade-20)}", 2000);
_inject(".ev1nejdyq{gap:5px}", 2000);
_inject(".ev14odnwx{padding:5px}", 1000);
_inject(".ev1tgzv6z{height:var(--field-height)}", 4000);
_inject(".ev1717udv{padding:0}", 1000);
_inject(".evha96y3{border-style:dotted}", 2000);
_inject(".ev71xlcl{border-color:red}", 2000);
_inject(".ev1a2a7pz{outline:none}", 2000);
_inject(".ev98rzlu{flex:1}", 2000);
_inject(".ev1mac9bf::placeholder{color:var(--shade-30)}", 8000);
_inject(".evwnonoy{background-color:var(--accent)}", 3000);
_inject(".ev1tzx33q{color:var(--text-on-accent)}", 3000);
_inject(".evorixrz{border-radius:100%}", 2000);
_inject(".ev9ms5i6{padding:3px}", 1000);
_inject(".ev1xp8n7a{width:18px}", 4000);
_inject(".evmix8c7{height:18px}", 4000);
_inject(".ev1kijww5{border-color:var(--shade-required-border)}", 2000);
_inject(".ev1lko15j{background-color:var(--shade-required)}", 3000);
_inject(".evip966{color:var(--text-on-required)}", 3000);
_inject(".evg5sszh:hover{background-color:#3333331A}", 3130);
_inject(".ev2boadx:active{background-color:#33333333}", 3170);
var ui = {
  textfield_container: {
    "PickDate__ui.textfield_container": "PickDate__ui.textfield_container",
    backgroundColor: "ev1y7ric0",
    borderWidth: "evmkeg23",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "ev1y0btm7",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: "evsqfd0d",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    borderRadius: "evxwrc4x",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    display: "ev78zum5",
    gap: "ev1nejdyq",
    rowGap: null,
    columnGap: null,
    padding: "ev14odnwx",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    width: "evh8yej3",
    height: "ev1tgzv6z",
    alignItems: "ev6s0dn4",
    $$css: true
  },
  textfield: {
    "PickDate__ui.textfield": "PickDate__ui.textfield",
    backgroundColor: "evjbqb8w",
    padding: "ev1717udv",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    borderWidth: "evc342km",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "evha96y3",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: "ev71xlcl",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    outline: "ev1a2a7pz",
    outlineColor: null,
    outlineOffset: null,
    outlineStyle: null,
    outlineWidth: null,
    width: "evh8yej3",
    flex: "ev98rzlu",
    flexGrow: null,
    flexShrink: null,
    flexBasis: null,
    color: "ev17e5z5g",
    "::placeholder_color": "ev1mac9bf",
    $$css: true
  },
  clear_button: {
    "PickDate__ui.clear_button": "PickDate__ui.clear_button",
    transition: "ev1h2kqdt",
    transitionBehavior: null,
    transitionDelay: null,
    transitionDuration: null,
    transitionProperty: null,
    transitionTimingFunction: null,
    borderRadius: "evorixrz",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    padding: "ev9ms5i6",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    width: "ev1xp8n7a",
    height: "evmix8c7",
    display: "ev78zum5",
    alignItems: "ev6s0dn4",
    justifyContent: "evl56j7k",
    backgroundColor: "evjbqb8w ev1dfczft evfge0gx",
    $$css: true
  },
  required: {
    "PickDate__ui.required": "PickDate__ui.required",
    borderColor: "ev1kijww5",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    backgroundColor: "ev1lko15j",
    color: "evip966",
    $$css: true
  },
  clear_button_on_required: {
    "PickDate__ui.clear_button_on_required": "PickDate__ui.clear_button_on_required",
    backgroundColor: "evjbqb8w evg5sszh ev2boadx",
    $$css: true
  }
};